import axios from 'axios';
import React,{useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { check_subscription_api } from '../Services/Apis';
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Redirect = () => {
    const params = new URLSearchParams(window.location.search)
    const msisdn = params.get('msisdn');
    const ext_ref = params.get('ext_ref')

    console.log(msisdn)

    const navigate = useNavigate()

    const CheckUser=async()=>{
        console.log(msisdn)
        try{
            if(msisdn){
                const response = await axios.get(`${check_subscription_api}?msisdn=${msisdn}`);
                if(response.data == 'SUCCESS' || response.data == 'success'){
                    Cookies.set('sub_number',msisdn,{expires:1});
                    navigate('/home')
                }
                else{
                    navigate(`/pack?msisdn=${msisdn}&ext_ref=${ext_ref}`)
                }
            }
            else{
                navigate(`/subscribe?ext_ref=${ext_ref}`)
            }
           
        }
        catch(err){
            console.log(err);
             if(err.response.status == 404){
                        navigate(`/pack?msisdn=${msisdn}&ext_ref=${ext_ref}`)
                      }
                      else if(err.response.status == 402 || err.response.status == 403){
                        toast.error("INSUFFICIENT BALANCE!!");
                        navigate(`/subscribe?ext_ref=${ext_ref}`)
                      }
            
        }
    }

    useEffect(()=>{
        CheckUser()
    },[])

  return (
    <div>
    </div>
  )
}

export default Redirect
